import React from 'react';
import { useSideMenu } from '../contexts/SideMenuContext';

const Navbar: React.FC = () => {
  const { toggleMenu } = useSideMenu();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-slate-900/80 backdrop-blur-md border-b border-slate-700/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-sm">LU</span>
            </div>
            <span className="text-white font-jetbrains font-bold text-xl bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">
              LunaUno
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="/" className="text-slate-300 hover:text-cyan-400 transition-colors duration-200 font-jetbrains">
              Inicio
            </a>
            <a href="/consoles" className="text-slate-300 hover:text-cyan-400 transition-colors duration-200 font-jetbrains">
              Consolas
            </a>
            <a href="/bios" className="text-slate-300 hover:text-cyan-400 transition-colors duration-200 font-jetbrains">
              BIOS
            </a>
            <a href="/legal" className="text-slate-300 hover:text-cyan-400 transition-colors duration-200 font-jetbrains">
              Legal
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={toggleMenu}
            className="md:hidden p-2 rounded-lg text-slate-300 hover:text-white hover:bg-slate-800/50 transition-colors duration-200"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>
    </nav>
  );
};


export default Navbar;

